import { Routes } from '@angular/router';
import { OverviewComponent } from './features/overview/overview.component';
import { PersonalAccessTokenComponent } from './features/personal-access-token/personal-access-token.component';
import { SepaDetailComponent } from './features/detail/sepa-detail/sepa-detail.component';
import { CompletedComponent } from './features/completed/completed.component';
import { VerificationErrorComponent } from './errors/verification-error/verification-error.component';
import { AlreadySentComponent } from './errors/already-sent/already-sent.component';
import { ServerErrorComponent } from './errors/server-error/server-error.component';
import { CheckForTokenGuard } from './shared/guards/token-guard';
import { PersonalAccessTokenGuard } from './shared/guards/personal-access-token-guard';
import { landingpageConfigurationGuard } from './shared/guards/landingpage-configuration.guard';
import { PaypalDetailComponent } from './features/detail/paypal-detail/paypal-detail.component';

export const routes: Routes = [
  {
    path: '',
    title: 'Zugangscodeabfrage',
    component: PersonalAccessTokenComponent,
  },
  {
    path: 'verify',
    title: 'Zugangscodeabfrage',
    canActivate: [CheckForTokenGuard],
    component: PersonalAccessTokenComponent,
  },
  {
    path: '',
    canActivate: [PersonalAccessTokenGuard],
    canActivateChild: [landingpageConfigurationGuard], //to ensure this guard is run after PAT guard
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'case',
        title: 'Zahlungsübersicht',
        component: OverviewComponent,
      },
      {
        path: 'payment/paypal',
        title: 'Zahlung via PayPal',
        component: PaypalDetailComponent,
      },
      {
        path: 'payment/sepa',
        title: 'Zahlung via SEPA',
        component: SepaDetailComponent,
      },
      {
        path: 'completed',
        title: 'Zahlung abgeschlossen',
        component: CompletedComponent,
      },
    ],
  },
  {
    path: 'already-sent',
    title: 'Daten bereits abgesendet',
    component: AlreadySentComponent,
  },
  {
    path: 'verification-error',
    title: 'Verifizierung nicht möglich',
    component: VerificationErrorComponent,
  },
  {
    path: 'error',
    title: 'Ein Fehler ist aufgetreten',
    component: ServerErrorComponent,
  },
];
